import { Phone, MessageCircle } from "lucide-react";
import { BRAND, waLink } from "@/data/content";

export default function CtaBand({ compact = false }) {
  return (
    <section className={compact ? "cta-band compact" : "cta-band"} data-testid="cta-band">
      <div>
        <div className="eyebrow gold">Free Guidance</div>
        <h2>Need Help With Insurance, Investment, Tax or GST?</h2>
        <p>Talk to Utkarsh Gupta — seedhi baat, sahi salah, bina kisi charge ke pehli consultation.</p>
      </div>
      <div className="cta-band-actions">
        <a href={waLink("Namaste Utkarsh ji, mujhe insurance / investment / tax ke baare mein consultation chahiye.")} target="_blank" rel="noopener noreferrer" className="btn btn-whatsapp" data-testid="cta-band-whatsapp">
          <MessageCircle size={17} /> WhatsApp Consultation
        </a>
        <a href={`tel:+91${BRAND.phone1}`} className="btn btn-light" data-testid="cta-band-call">
          <Phone size={17} /> Call Now
        </a>
      </div>
    </section>
  );
}
